import {defineStore} from "pinia";

const useMySongStore = defineStore({
    id: "mySong",
    state: () => {
        return {
            songList: [],
        }
    },
    actions: {
        setSongItem(data){
            this.songList.push(data)
        },
        setSongList(list){
            this.songList.push(...list)
            let obj = {};
            let arr = this.songList
            arr = arr.reduce((newArr, next) => {
                obj[next.rid] ? "" : (obj[next.rid] = true && newArr.push(next));
                return newArr;
            }, []);
            this.songList = arr
        },
        deleteSongItem(data){
            this.songList.map((item, index) => {
                if (item.rid == data.rid) {
                    this.songList.splice(index, 1);
                }
            });
        },
    },
    getters: {
        musicList() {
            let obj = {};
            let arr = this.songList
            arr = arr.reduce((newArr, next) => {
                obj[next.rid] ? "" : (obj[next.rid] = true && newArr.push(next));
                return newArr;
            }, []);
            return arr;
        }
    },
    persist: {
        enabled: true,
        strategies: [
            {storage: localStorage, paths: ['musicList']},
        ],
    },
})

export default useMySongStore
